module.exports = __webpack_public_path__ + "static/media/Datas_Arqui._Integracao.ff227c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Datas_Arqui._Integracao.png
// module id = 235
// module chunks = 0